export default 
{
	"progressbar-page-title": "Oldal",
	"name-suffix": "Utótag",
	"fileupload-desc-progress-message": "Feltöltés {progress}",
	"required-if-greater-than-or-equal": "{property} megadása kötelező, ha {compareSource} {compareValue} vagy több.",
	"powered-by-cognito": "Cognito Forms által működtetett.",
	"form-name-default": "Névtelen",
	"field-choice-defaults": "Első választás|Második választás|Harmadik választás",
	"additional-fee-default-label": "Kiegészítő díj",
	"authenticated-save-and-resume-email-dialog": "Küldjön egy linket e-mailben, és térjen vissza az űrlaphoz a beküldés befejezéséhez.",
	"string-length-between": "{Property} között kell lennie {min} és {max} karakter.",
	"update-button-text": "Frissítés",
	"address-zip-code-invalid": "Az irányítószám formátuma legyen #####-####.",
	"required-if-greater-than": "{property} megadása kötelező, ha {compareSource} több mint {compareValue}.",
	"compare-before": "{property} legyen {compareSource} előtt.",
	"compare-after": "{property} legyen {compareSource} után.",
	"unsupported-browser-message": "Jaj ne! A böngésződ nem támogatott. {a}Kattints ide{/a} a frissítéshez.",
	"shared-entry-email-subject": "Megosztott Link",
	"send-button-text": "Küldés",
	"venmo-help-text": "Csatlakozzon a Venmo-hoz a fizetés folytatásához.",
	"field-repeatingsection-item-label": "Tétel",
	"save-and-resume-email-not-sent-message": "Volt egy probléma.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} legyen legalább {min}.",
	"entry-notification-full-entry-detail-link": "A teljes bejegyzést megtekintheted a cognitoforms.com oldalon. ",
	"element-label-website": "Honlap",
	"element-label-signature": "Aláírás",
	"paypal-help-text": "Csatlakozzon a PayPal-hoz a fizetés folytatásához.",
	"card-on-file-agreement-validation": "El kell fogadnia, hogy mentse a kártyáját a jövőbeli tranzakciókhoz.",
	"marketing-button-4": "Építsd meg a sajátodat ingyen",
	"field-datepicker-now": "Most",
	"save-and-resume-email-resume-button": "Folytatás most",
	"field-datepicker-next-month": "Következő hónap",
	"quantity-remaining-text": "hátralevő",
	"payment-declined": "Fizetés elutasítva.",
	"required-if-before": "{property} megadása kötelező, ha {compareSource} {compareValue} előtt van.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} legyen kevesebb mint {compareSource}.",
	"entry-admin-link": "Adminisztrációs link",
	"required-many": "{0} megadása kötelező.",
	"save-and-resume-multiple-days-expiration-email-message": "Használd az alábbi linket, hogy visszatérhess a következő {days} napban befejezni az űrlap kitöltését.",
	"string-length-at-least": "{property} formátuma {description}.",
	"credit-card-number": "Bankkártyaszám",
	"range-on-or-before": "{property} legyen {max}-n vagy előbb.",
	"required-one": "{0} megadása kötelező.",
	"fileupload-max-file-count-exceeded-message": "Csak {maxFileCount} fájl feltöltése lehetséges.",
	"order-transaction-details-header": "Tranzakció részletei",
	"field-spinner-increase": "Növel",
	"payment-processing-fees": "Feldolgozási díj",
	"payment": "Fizetés",
	"field-choice-other-fill-in": "Egyéb",
	"shared-entry-email-message": "Megosztottak veled egy bejegyzést.",
	"shared-entry-workflow-link": "Nézze meg az űrlapot.",
	"required-if-exists": "{property} megadása kötelező, ha {compareSource} meg van adva.",
	"concurrent-conflict-toast-message": "Beküldése sikertelen volt, mert az űrlapon szereplő adatok megváltoztak. Kérjük, ellenőrizze, és próbálja újra.",
	"secured-by-paypal": "által védett",
	"range-on-or-after": "{property} legyem {min}-n vagy később.",
	"payment-amount-due": "Végösszeg",
	"required-name-first-and-last": "A kereszt- és vezetéknév megadása kötelező.",
	"required": "{property} megadása kötelező.",
	"string-format-alphabetic": "{property} legfeljebb {max} karakter lehet.",
	"quantity-limit": "{property} mennyiség meghaladta.",
	"field-spinner-decrease": "Csökken",
	"field-repeatingsection-add-link-text": "Hozzáadás",
	"fileupload-max-size-exceeded-message": "Csak {maxSize} MB-nál kisebb fáljok feltöltése lehetséges.",
	"credit-card-expiration": "HH/ÉÉ",
	"field-signature-notcaptured": "Nem lett rögzítve",
	"field-ratingscale-satisfied-unsatisfied-label": "Elégedett/Elégedetlen",
	"range-between": "{property} legyen {min} és {max} között.",
	"field-ratingscale-agree-disagree-label": "Egyetért/Nem ért egyet",
	"back-button-text": "Vissza",
	"address-country": "Ország",
	"order-not-found": "Nem találtunk rendelési információt.",
	"field-ratingscale-satisfied-unsatisfied-options": "Nagyon Elégedetlen|Elégedetlen|Közömbös|Elégedett|Nagyon Elégedett",
	"entry-notification-entry-details-header": "Bejegyzés részletei",
	"FALSE": "Hamis",
	"compare-greater-than-or-equal": "{property} legyen több, vagy egyenlő mint {compareSource}.",
	"receipt-notification-order-details-desc-header": "Leírás",
	"order-method-label": "Mód",
	"order-total-label": "Rendelés végösszege",
	"invalid-shared-link": "Érvénytelen megosztott link",
	"fileupload-zero-byte-file-message": "Nulla bájtos fájlok feltöltése nem lehetséges.",
	"range-at-most": "{property} legyen legfeljebb {max}.",
	"format-integer": "####",
	"order-date-label": "Dátum",
	"fileupload-dropzone-message": "vagy húzd ide a fájlokat.",
	"shared-entry-view-link": "Megosztott bejegyzés megtekintése.",
	"format-currency": "# ###,## Ft",
	"string-length-at-most": "{property} formátuma helytelen.",
	"entry-confirmation-footer-tagline": "Készítsd el a saját erőteljes fizető űrlapjaidat",
	"submit-button-text": "Beküldés",
	"marketing-msg": "Készíts erőteljes űrlapokat könnyen.",
	"required-if-on-or-after": "{property} megadása kötelező, ha {compareSource} {compareValue}-n vagy később van.",
	"card-on-file-agreement": "Elfogadom, hogy megmentem a kártyámat a jövőbeli tranzakciókhoz.",
	"signature-draw": "rajzol",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} legyen {compareSource}-n vagy később.",
	"required-if-less-than-or-equal": "{property} megadása kötelező, ha {compareSource} {compareValue} vagy kevesebb.",
	"field-datepicker-next-year": "Következő év",
	"change-button": "változik",
	"fileupload-desc-size-in-bytes-message": "{size} bájt",
	"card-tab": "Kártya",
	"order-billing-info-header": "Számlázási adatok",
	"entry-email-view-details-text": "A teljes bejegyzést megtekintheted a CognitoForms.com oldalon. ",
	"save-and-resume-one-day-expiration-email-message": "Használd az alábbi linket, hogy visszatérhess a következő egy napban befejezni az űrlap kitöltését.",
	"credit-card-authentication-failed": "A kártya sikertelen hitelesítése.",
	"compare-less-than-or-equal": "{property} legyen kevesebb, vagy egyenlő mint {compareSource}.",
	"receipt-notification-order-details-balance-due": "Fizetendő összeg",
	"save-and-resume-multiple-days-expiration-message": "Másold le vagy küldd el emailben az alábbi linket, majd térj vissza a következő {days} napban befejezni az űrlap kitöltését.",
	"processing-fee-calculating-message": "Számolás",
	"receipt-notification-trx-details-method": "Mód",
	"field-choice-no-match": "Nincs találat",
	"fileupload-invalid-file-type-message": "Csak {allowedTypes} formátú fájlok feltöltése lehetséges.",
	"receipt-notification-trx-details-date": "Dátum",
	"credit-card-authorization": "Kártya felhatalmazása",
	"address-line1": "Cím első sor",
	"required-if-not-exists": "{property} megadása kötelező, ha {compareSource} nincs megadva.",
	"required-if-not-equal": "{property} megadása kötelező, ha {compareSource} nem {compareValue}.",
	"marketing-button-2": "Építsd meg a sajátodat ingyen",
	"receipt-notification-billing-info-header": "Számlázási adatok",
	"required-if-after": "{property} megadása kötelező, ha {compareSource} {compareValue} után van.",
	"element-label-name": "Név",
	"required-if-equal": "{property} megadása kötelező, ha {compareSource} és {compareValue} megegyezik.",
	"connected-to-paypal": "Csatlakozva a PayPalhoz.",
	"people-form-email-quantity-exceeded-message": "Az e-mail címnek egyedinek kell lennie.",
	"receipt-notification-order-details-subtotal": "Részösszeg",
	"shared-entry-edit-link": "Megosztott bejegyzés szerkesztése.",
	"receipt-notification-trx-details-header": "Tranzakció részletei",
	"address-city": "Város",
	"receipt-notification-order-details-amount-paid": "Fizetett összeg",
	"credit-card-invalid": "A kártya érvénytelen.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Új űrlapbejegyzés érkezett.",
	"this-and-that": "{0} és {1}",
	"field-ratingscale-good-poor-label": "Jó/Rossz",
	"network-unavailable-message": "A hálózat nem érhető el, próbálkozzon újra később.",
	"dialog-close": "Becsuk",
	"string-format-alphanumeric": "{property} {min}-{max} karakter lehet.",
	"credit-card": "Bankkártya",
	"remove-item": "Eltávolítás {item}",
	"receipt-notification-order-details-price-header": "Ár",
	"fileupload-upload-inprogress-message": "Fájlfeltöltés folyamatban.",
	"public-terms-of-service-link-text": "Szolgáltatás Feltételei",
	"save-and-resume-email-subject": "Mentés \u0026 Folytatás Link",
	"field-repeatingsection-remove-link-text": "Eltávolítás",
	"field-ratingscale-na-label": "Nem elérhető",
	"add-item": "Hozzáadás {item}",
	"field-toggle-options": "Igen/Nem|Igaz/Hamis|Nyitva/Zárva|Aktív/Inaktív|Olvasott/Olvasatlan",
	"order-submit-timeout": "A rendelés feldolgozása túl sokáig tart. Kérünk próbáld újra később.",
	"listlength-at-most": "Ne adj meg több mint {max} {property}.",
	"shared-entry-email-view-message": "Használd az alábbi linket a megosztott bejegyzés megtekintéséhez.",
	"order-number-label": "Szám",
	"card-declined": "Kártya elutasítva",
	"fileupload-default-upload-button-text": "Feltöltés",
	"name-prefix": "Cím",
	"address-line2": "Cím második sor",
	"element-label-email": "Email",
	"field-ratingscale-good-poor-options": "Nagyon rossz|Rossz|Átlagos|Jó|Nagyon jó",
	"next-button-text": "Következő",
	"question": "Kérdés",
	"address-postalcode": "Irányítószám",
	"format-with-description": "{Property} kell formázni {description}.",
	"field-datepicker-prev-month": "Előző hónap",
	"name": "Név",
	"receipt-notification-order-details-total-footer": "Végösszeg",
	"confirmation-message": "Köszönjük, hogy kitöltötted az űrlapot. Válaszodat rögzítettük.",
	"shared-entry-email-edit-message": "Használd az alábbi linket a megosztott bejegyzés szerkesztéséhez.",
	"field-default-label": "Névtelen",
	"required-value": "A (z) {property} értékének {value} kell lennie.",
	"name-middle": "Középső név",
	"fileupload-failed-upload-message": "{fileName} feltöltése sikertelen.",
	"shared-entry-email-button-label": "Bejegyzés megtekintése.",
	"field-datepicker-year": "",
	"element-label-phone": "Telefon",
	"TRUE": "Igaz",
	"listlength-between": "Adj meg {min}-{max} {property}.",
	"marketing-button-1": "Próbáld ki most",
	"entry-submission-error-heading": "Hiba a feldolgozás során",
	"order-not-found-message": "Nem találtunk rendelési információt.",
	"format-without-description": "{Property} nem megfelelő formátumú.",
	"name-last": "Vezetéknév",
	"field-ratingscale-one-five-label": "1-től 5-ig terjedő skála",
	"listlength-at-least": "Adj meg legalább {min} {property}.",
	"united-states": "Egyesült Államok",
	"field-signature-captured": "Rögzítve",
	"compare-on-or-before": "{property} legyen {compareSource}-n vagy előbb.",
	"order-balance-due-label": "Esedékes összeg",
	"required-if-less-than": "{property} megadása kötelező, ha {compareSource} kevesebb mint {compareValue}.",
	"credit-card-postalcode": "Irányítószám",
	"form-not-available-message": "Az űrlap jelenleg nem elérhető.",
	"element-label-address": "Cím",
	"receipt-notification-trx-details-number": "Szám",
	"public-submission-warning": "Kérjük, ne küldj jelszavakat a Cognito Forms-on keresztül",
	"save-and-resume-no-expiration-email-message": "Használd az alábbi linket, hogy visszatérhess befejezni az űrlap kitöltését.",
	"fileupload-excluded-file-type-message": "Ilyen formátumú fájl feltöltése nem lehetséges.",
	"payment-subtotal": "Részösszeg",
	"collapse": "Összecsukás",
	"save-button-text": "Mentés",
	"field-datepicker-prev-year": "Előző év",
	"signature-type": "beír",
	"order-amount-minimum": "A Végösszeg minimum $1.00.",
	"string-format-numeric": "{property} legyen legalább {min} karakter.",
	"entry-confirmation-entry-details-header": "Bejegyzés részletei",
	"connected-to-venmo": "Csatlakoztatva a Venmohoz.",
	"format-percentage": "#,##%",
	"receipt-notification-header": "Bizonylat",
	"clear": "Törlés",
	"today": "Ma",
	"required-name-last": "A vezetéknév megadása kötelező.",
	"marketing-button-3": "Próbáld ki most",
	"expand": "Kibont",
	"compare-greater-than": "{property} legyen több mint {compareSource}.",
	"field-ratingscale-will-wont-label": "Fog/Nem fog",
	"required-name-first": "A keresztnév megadása kötelező.",
	"save-and-resume-one-day-expiration-message": "Másold le vagy küldd el emailben az alábbi linket, majd térj vissza egy napon belül befejezni az űrlap kitöltését.",
	"required-asterisk": "megadása kötelező",
	"credit-card-required": "Bankkártya megadása kötelező.",
	"address-state-province-region": "Állam / Megye / Térség",
	"save-and-resume-email-sent-message": "Az email elküldve.",
	"workflow-action": "Akció",
	"field-ratingscale-will-wont-options": "Biztosan nem fog|Valószínűleg nem fog|Bizonytalan|Valószínűleg fog|Biztosan fog",
	"save-and-resume-email-label": "Küldd el nekem emailben a linket:",
	"field-ratingscale-agree-disagree-options": "Nagyon nem ért egyet|Nem ért egyet|Közömbös|Egyetért|Nagyon egyetért",
	"order-exception-order-already-paid": "A rendelés már ki van fizetve.",
	"fileupload-download-text": "Letöltés",
	"address-state": "Állam",
	"allowed-values": "{property} nem szerepel a megengedett értékek listáján.",
	"shared-entry-workflow-email-button-label": "Nyissa meg az űrlapot",
	"compare-equal": "{property} legyen ugyanaz mint {compareSource}.",
	"field-datepicker-clear": "Törlés",
	"name-first": "Keresztnév",
	"save-and-resume-message": "Előrehaladásodat mentettük.",
	"save-and-resume-no-expiration-message": "Másold le vagy küldd el emailben az alábbi linket, majd térj vissza később befejezni az űrlap kitöltését.",
	"entry-notification-view-details-text": "Részletek megtekintése",
	"order-exception-default-message": "A tranzakció feldolgozása sikertelen.",
	"public-report-abuse-link-text": "Visszaélés jelentése",
	"order-amount-paid": "Fizetett összeg",
	"element-label-default": "Névtelen",
	"countries": "Afganisztán|Albánia|Algéria|Amerikai Szamoa|Andorra|Angola|Anguilla|Antarktika|Antigua és Barbuda|Argentína|Örményország|Aruba|Ausztrália|Ausztria|Azerbajdzsán|Bahama-szigetek|Bahrein|Banglades|Barbados|Fehéroroszország|Belgium|Belize|Benin|Bermuda|Bhután|Bolívia|Bosznia-Hercegovina|Botswana|Brazília|Brunei|Bulgária|Burkina Faso|Burundi|Kambodzsa|Kamerun|Kanada|Zöld-foki Köztársaság|Kajmán-szigetek|Közép-afrikai köztársaság|Csád|Chile|Kína|Karácsony-sziget|Kókusz (Keeling)-szigetek|Kolumbia|Comore-szigetek|Kongói Köztársaság (Brazzaville)|Cook-szigetek|Costa Rica|Horvátország|Kuba|Ciprus|Cseh Köztársaság|Kongói Demokratikus Köztársaság (Kinshasa)|Dánia|Dzsibuti|Dominikai Közösség|Dominikai Köztársaság|Kelet-Timor (Timor-Leste)|Ecuador|Egyiptom|Salvador|Egyenlítői-Guinea|Eritrea|Észtország|Etiópia|Falkland-szigeter|Feröer|Fidzsi-szigetek|Finnország|Franciaország|Francia Guyana|Francia Polinézia|Francia déli és antarktiszi területek|Gabon|Gambia|Grúzia|Németország|Ghána|Gibraltár|Nagy-Britannia|Görögország|Grönland|Grenada|Guadeloupe|Guam|Guatemala|Guinea|Bissau-Guinea|Guyana|Haiti|Apostoli Szentszék|Honduras|Hong Kong|Magyarország|Izland|India|Indonézia|Irán|Irak|Írország|Izrael|Olaszország|Elefántcsontpart|Jamaica|Japán|Jordánia|Kazahsztán|Kenya|Kiribati|Koreai Népi Demokratikus Köztársaság (Észak-Korea)|Koreai Köztársaság (Dél-Korea)|Koszovó|Kuvait|Kirgizisztán|Laoszi Népi Demokratikus Köztársaság|Lettország|Libanon|Lesotho|Libéria|Líbia|Liechtenstein|Litvánia|Luxemburg|Makaó|Észak-Macedónia|Madagaszkár|Malawi|Malajzia|Maldív-szigetek|Mali|Málta|Man sziget|Marshall-szigetek|Martinique|Mauritánia|Mauritius|Mayotte|Mexikó|Mikronéziai Szövetségi Államok|Moldovai Köztársaság|Monaco|Mongólia|Montenegró|Montserrat (sziget)|Marokkó|Mozambiki Köztársaság|Mianmar, Burma|Namíbia|Nauru|Nepál|Hollandia|Holland Antillák|Új-Kaledónia|Új-Zéland|Nicaragua|Niger|Nigéria|Niue|Északi-Mariana-szigetek|Norvégia|Omán|Pakisztán|Palau|Palesztin Autonómia|Panama|Pápua Új-Guinea|Paraguay|Peru|Fülöp-szigetek|Pitcairn-szigetek|Lengyelország|Portugália|Puerto Rico|Katar|Réunion|Románia|Oroszországi Föderáció|Ruanda|Saint Kitts és Nevis|Saint Lucia|Saint Vincent és a Grenadine-szigetek|Szamoa|San Marino|São Tomé és Príncipe|Szaúd-Arábia|Szenegál|Szerbia|Seychelle-szigetek|Sierra Leone|Szingapúr|Szlovákia (Szlovák Köztársaság)|Szlovénia|Salamon-szigetek|Szomália|Dél-afrikai Köztársaság|Dél-Szudán|Spanyolország|Sri Lanka|Szudán|Suriname|Szváziföld|Svédország|Svájc|Szíria, Szíriai Arab Köztársaság|Tajvan (Kínai Köztársaság)|Tádzsikisztán|Tanzánia; hivatalosan Tanzániai Egyesült Köztársaság|Thaiföld|Tibet|Kelet-Timor|Togo|Tokelau-szigetek|Tonga|Trinidad és Tobago|Tunézia|Törökország|Türkmenisztán|Turks- és Caicos-szigetek|Tuvalu|Uganda|Ukrajna|Egyesült Arab Emírségek|Egyesült Királyság|Amerikai Egyesült Államok|Uruguay|Üzbegisztán|Vanuatu|Vatikán Állam (Apostoli Szentszék)|Venezuela|Vietnam|Virgin-szigetek (Brit)|Virgin-szigetek (Amerikai)|Wallis és Futuna|Nyugat-Szahara|Jemen|Zambia|Zimbabwe",
	"name-middleinitial": "Középső kezdőbetű",
	"order-exception-empty-order": "A rendelésnek legalább 1 tételt tartalmaznia kell.",
	"compare-not-equal": "{property} legyen különböző mint {compareSource}.",
	"entry-notification-footer": "Azért kapod ezt az emailt, mert a Cognito Forms űrlapodon bejelölted az emailes értesítések lehetőségek.",
	"save-and-resume-copy-link-label": "Másold le az űrlapod linkjét:",
	"entry-confirmation-footer": "Azért kapod ezt az emailt, mert befejeztél egy tranzakciót [Name].",
	"required-if-on-or-before": "{property} megadása kötelező, ha {compareSource} {compareValue}-n vagy előbb van.",
	"string-format": "{property} formátuma legyen {formatDescription}."
};
